const localUser = "user";

export const getUserDetails = () => {
    let userData = {};
    try {
        userData = JSON.parse(localStorage.getItem(localUser));
    } catch (e) {
        console.log("Error parsing user data:", e);
    } finally {
        return userData;
    }
}

export const clearLocalStorage = () => {
    localStorage.clear();           
    window.location.href = "/login"; 
}